import clsx from 'clsx';
import { FC } from 'react';
import { LandingImageTextTileStoryblok } from 'storyblok-types';
import { Container } from '../../../atoms/Container';
import { LandingImageTextTileItem } from './LandingImageTextTileItem';
import styles from './styles.module.css';

export const LandingImageTextTile: FC<{
  blok: LandingImageTextTileStoryblok;
}> = ({ blok }) => {
  const { landingImageTextTile, isFourColumnGrid } = blok;

  return !landingImageTextTile?.length ? null : (
    <Container>
      <div
        className={clsx(styles.root, isFourColumnGrid && styles.fourColumnGrid)}
      >
        {landingImageTextTile.map((item) => (
          <LandingImageTextTileItem key={item._uid} blok={item} />
        ))}
      </div>
    </Container>
  );
};
